export function Splash({ title, detail }: { title: string; detail: string }) {
  return (
    <div
      style={{
        height: "100%",
        display: "grid",
        placeItems: "center",
        background: "var(--ink)",
        color: "var(--paper)",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <div className="label" style={{ color: "var(--ink-faint)" }}>
          Methacore
        </div>
        <h1 style={{ fontSize: 34, fontWeight: 600, margin: "10px 0 6px" }}>{title}</h1>
        <p style={{ color: "var(--ink-faint)", margin: 0 }}>{detail}</p>
      </div>
    </div>
  );
}
